import { Subscription } from 'rxjs';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DetalheBaseController } from '../../helpers';
import { DevedorService } from '../../services'; 
import { WizardStepComponent } from './wizard-step.component';
import { LogWizardService } from '../../services/logWizard.service';
import { AcordoService } from '../../services';
import { DomSanitizer  } from '@angular/platform-browser';
import * as _ from 'underscore';

@Component({
    templateUrl: 'principal.component.html',
})

export class PrincipalComponent extends DetalheBaseController{
    subLigacao: Subscription; 
    dividasSelecionadas: any = [];   
    ligacoes: any = [];
    usuario: any;
    endereco: string;  
    selecaoContrato: boolean = false;        
    disabledStepConcluir: boolean = false;
    showloadAudio: boolean = false;
    showEndereco: boolean = false; 
    _showChatbot: boolean = false;
    dividas: any = [];        
    lastTotal: number = 0;  
    urlChatbot: string = "";  
    _usaChatbot: boolean = false;  
    _usaWizard: boolean = true;

    constructor(private router: Router, route: ActivatedRoute, 
        private activatedRoute: ActivatedRoute,  
        private _devedor: DevedorService,
        private _logWizardService: LogWizardService,
        private _devedorService: DevedorService,
        private _acordoService: AcordoService,
        public sanitizer: DomSanitizer) {
        super(route, _devedor); 
    }

    ngOnInit() {              
        this.usuario = JSON.parse(localStorage.getItem('currentUserCobranca'));
        if (this.usuario != null) {            
            this.getlistaAudios(this.usuario.devId);              
            this.subGet = this._devedorService.getDevedorLogado().subscribe(result => {
                this.model = result;                         
                this.setEnderecoDevedor(this.model.enderecosAtivos)
            });            
        }
    }

    receberDividasSelecionadas(dividas) {          
        this.dividasSelecionadas = dividas;                
        this.trataDividas();        
    }      

    validaSelecao(value) {        
        this.selecaoContrato = value;        
    } 

    habilitarStepConcluir(value) {                
        this.disabledStepConcluir = value;
    }

    getlistaAudios(devedorid: any) {
        this.showloadAudio = true;
        this.subLigacao = this._devedor.getlistaAudios(devedorid).subscribe(result => {            
            this.ligacoes = result; 
            this.showloadAudio = false; 
        });
    }

    getStepAtual(step: WizardStepComponent){        
        this._logWizardService.postLogWizard(step.id);        
    }

    setEnderecoDevedor(modelEndereco: any)
    {
        if (modelEndereco.length >= 1 ) {        
            this.showEndereco = true;                   
            this.endereco = `${modelEndereco[0].logradouro}, ${modelEndereco[0].numero}, ${modelEndereco[0].bairro}`;
        }
    }

    showChatbot() {
        this._showChatbot = !this._showChatbot;
    }

    montaUrlChatbot() {        
        var maxParcela: any;
        var maxDesconto: any;
        maxParcela = _.max(this.dividas[0].parcelas, _.property("index"));
        maxDesconto = _.max(this.dividas[0].parcelas, _.property("percentualDesconto"));

        this.urlChatbot = "https://talkbot.paneas.com/chat_profile_skin_tag_talk?key_chat=9721081ce9d92ab163569efa64219ce2&dados=" + this.usuario.nome + 
        "|" + this.usuario.cpfCnpj + "|" + this.usuario.telefone + "|" + this.dividas[0].valorTotal.toString().replace(".", ",") + "|" + maxParcela.index + 
        "|" + maxDesconto.percentualDesconto + "|" + this.usuario.devId + "|0";                
        this._usaChatbot = true;
        this._showChatbot = true;
    }

    trataDividas() {
        if (this.dividasSelecionadas == undefined || this.dividasSelecionadas.length <= 0) 
            return;          
        this.dividas = this.initObjDivida();
        var group = _.chain(this.dividasSelecionadas)
          .groupBy(e => e.contratoId)
          .map(e => (e[0].count = e.length, e[0])).value().filter(item => item.acordoDivida == null); 
        
        this._usaWizard = this.dividasSelecionadas[0].usaSelecao;

        if (group.reduce((acc, cur) => acc + cur.valorTotal, 0) == this.lastTotal)
            return;

        if (this.dividasSelecionadas[0].usaChatbot == false) {
            this._usaChatbot = false;
            return;
        }

        this.lastTotal = group.reduce((acc, cur) => acc + cur.valorTotal, 0);
        this._acordoService.getRegrasParcelamento(this.lastTotal).subscribe(result => {                                                   
            this.getDividas(group, result);
        });
    }

    getDividas(group, regrasParcelamento) {       
        this._loading.carregar();                        
        group.forEach(element => {                          
            this.dividas[0].contratoId += element.contratoId + ',';                
            this.dividas[0].numeroContrato += element.numeroContrato + ', ';             
            this.dividas[0].parcelaId += element.parcelaId + ','; 
            this.dividas[0].primeiroVencimento = element.primeiroVencimento;
            this.dividas[0].valorTotalComDesconto += element.valorTotalComDesconto;
            this.dividas[0].valorTotal += element.valorTotal;
            this.dividas[0].valorDoDesconto += element.valorDoDesconto;
            if (element.numeroMaximoParcela > this.dividas[0].numeroMaximoParcela) {
                this.dividas[0].numeroMaximoParcela = element.numeroMaximoParcela;                
                this.dividas[0].percentualMaximoDesconto = element.percentualMaximoDesconto;
            }
        });                

        this.dividas[0].numeroDivida = 1;
        this.dividas[0].numeroContrato = this.dividas[0].numeroContrato.substring(0, this.dividas[0].numeroContrato.length - 2)
        this.dividas[0].contratoId = this.dividas[0].contratoId.substring(0, this.dividas[0].contratoId.length - 1)
        this.dividas[0].parcelaId = this.dividas[0].parcelaId.substring(0, this.dividas[0].parcelaId.length - 1)          
        this.dividas[0].parcelas = this.ObterParcelas(this.dividas[0], regrasParcelamento);
        
        this.showForm = true; 
        this.montaUrlChatbot();
        this._loading.fecharTodos();                            
    }

    ObterParcelas(divida, regraParcelamento) {        
        let parcelas = [];
        let parcelaSelecionada =  1;
        
        divida.quantidadeParcelasSelecionada = parcelaSelecionada;
        for (let index = 1; index <= regraParcelamento.quantidadeMaximaParcelas; index++) {            
            var desconto =  regraParcelamento.parcelamentoDetalhe.filter(x => x.parcela == index);
            parcelas.push({ index: index, valorComDesconto: (divida.valorTotal * (1 - (desconto[0].desconto / 100))), 
                percentualDesconto: desconto[0].desconto, checked: index == parcelaSelecionada });
        }

        return parcelas;
    }

    initObjDivida() {
        return [{
            contratoId: "",        
            numeroContrato: "",
            numeroMaximoParcela: 0,
            parcelaId: "",
            quantidadeParcelasSelecionada: 0,
            percentualDesconto: 0,
            percentualMaximoDesconto: 0,
            primeiroVencimento: null,
            valorTotalComDesconto: 0,
            valorTotal: 0,
            valorDoDesconto: 0,
            numeroDivida: 0,
            meioPagamento: 1,
            parcelas: [{
                index: 0, 
                checked: false
            }]
        }];          
    }

    ngOnDestroy() {
        if (this.subLigacao) this.subLigacao.unsubscribe();            
        super.ngOnDestroy();
    }
}


// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/components/wizard/principal.component.ts